<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="commCdRows"
		selection
		:excel="isButton_(scrId, 'EX')"
		paging
		index
		@changedPage="onChangePage"
		@row-dblclick="rowDblclick"
		v-bind="commCdPagingInfo"
		:pageUnit="commCdPagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="commCdPagingInfo.totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plus" :onClick="addRow">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
				getMessage_('SWCC000138')
			}}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import * as yup from 'yup';
import { serviceComputed, serviceMethods } from '@common/CommonCode/store/helpers';
import { rootComputed } from '@/store/common/helpers';
import { utils } from '@sfaas/util';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		// options() {
		// 	return this.useYnOptions.slice(1, 3);
		// },
		rows() {
			let rows = this.commCdRows.forEach(row => {
				if (utils.$sf_isNull(row.commCdNameLangId)) row.commCdNameLangId = '[다국어 선택]';
				if (utils.$sf_isNull(row.commCdDescLangId)) row.commCdDescLangId = '[다국어 선택]';
				return row;
			});

			return rows;
		},
		columns() {
			return [
				// { label: 'No.', prop: 'rnum', width: '130px' },
				// { label: this.getMessage_('SWCC000141'), prop: 'status', width: '150px' },
				{ label: this.getMessage_('SWCC000142'), prop: 'commCdType', width: '200px' },
				{
					label: this.getMessage_('SWCC000150'),
					prop: 'commCd',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: this.isAdded
					}
				},
				{
					label: this.getMessage_('SWCC000151'),
					prop: 'commCdName',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('SWCC000152'),
					prop: 'commCdDesc',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 1000
					}
				},
				{
					label: this.getMessage_('SWCC000144'),
					prop: 'commCdSeq',
					width: '200px',
					form: {
						type: 'number'
					}
				},
				{
					label: this.getMessage_('SWCC000159'),
					prop: 'flg1',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('SWCC000160'),
					prop: 'flg2',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('SWCC001000'),
					prop: 'commCdNameLangId',
					width: '200px',
					type: 'render',
					sortable: false,
					clickEvent: this.commCdNameLangIdClick,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000999'),
					prop: 'commCdDescLangId',
					width: '200px',
					type: 'render',
					sortable: false,
					clickEvent: this.commCdDescLangIdClick,
					highlight: true
				},
				// {
				// 	label: this.getMessage_('SWCC000145'),
				// 	prop: 'useYn',
				// 	width: '200px',
				// 	form: {
				// 		type: 'select',
				// 		options: this.options
				// 	}
				// },
				{ label: this.getMessage_('SWCC000146'), prop: 'regDt', width: '250px' },
				{ label: this.getMessage_('SWCC000005'), prop: 'regId', width: '200px' },
				{ label: this.getMessage_('SWCC000171'), prop: 'chgDt', width: '250px' },
				{ label: this.getMessage_('SWCC000172'), prop: 'chgId', width: '200px' }
			];
		},
		commCdSchema() {
			return yup.object().shape({
				commCdType: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000168')]))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000168'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000168'), 20])),
				commCd: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000150')]))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000150'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000150'), 20])),
				commCdName: yup
					.string()
					.trim()
					.default('')
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000151'), 1]))
					.max(40, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000151'), 40])),
				commCdDesc: yup
					.string()
					.trim()
					.default('')
					.max(200, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000152'), 200]))
				// useYn: yup.string().trim().default('Y')
			});
		}
	},
	methods: {
		...serviceMethods,
		rowDblclick(row, column, event) {
			const { commCdType, commCd } = row;
			const { currentPage, pageUnit } = this.commCdDescPagingInfo;
			this.$sf_toggleLoading(true);
			this.selectCommCdDescList_({ commCdType, commCd, currentPage, pageUnit }).finally(() => {
				this.$sf_toggleLoading(false);
			});
			this.SET({ key: 'commCdDescModal', value: { ...this.commCdDescModal, show: true, selectedRow: row } });
		},
		isAdded: ({ row }) => row.status !== 'I',
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.searchCommCd_({ currentPage: currentPageVal, pageUnit: pageUnitVal, commCdType: this.currentCommCdType }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		},
		addRow() {
			if (!this.currentCommCdType) {
				return;
			}
			const selectedRows = this.$refs.table.getSelectedRows();
			const toggleRowSelection = this.$refs.table.getTable().toggleRowSelection;
			this.addCommCdRow_().then(addedRow => {
				selectedRows.push(addedRow);
				selectedRows.forEach(row => {
					toggleRowSelection(row);
				});
			});
			this.$refs.table.scrollBottom();
		},
		getSelectedRows() {
			const defaultObj = this.commCdSchema.cast();
			const rows = this.$refs.table
				.getSelectedRows()
				.map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value());
			return rows;
		},
		async onClickButton(action) {
			const selectedRows = this.getSelectedRows();
			if (!selectedRows || selectedRows.length === 0) {
				const errMsg = this.getMessage_(action === 'save' ? 'SWCC000434' : 'SWCC000418');
				this.$sf_toast({ type: 'error', message: errMsg, option: { duration: 3000 } });
				return;
			}
			const messageCode = {
				save: 'SWCC000501',
				delete: 'SWCC000108'
			}[action];
			const clickFn = {
				save: this.saveCommCd,
				delete: this.deleteCommCd
			}[action];
			await this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_(messageCode),
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('SWCC000203')
			});
		},
		async saveCommCd() {
			let selectedRows = this.getSelectedRows();
			const fail = (
				await Promise.all(
					selectedRows.map(row =>
						this.commCdSchema
							.validate(row)
							.then(() => ({ isValid: true }))
							.catch(e => ({ isValid: false, ...e }))
					)
				)
			).filter(r => !r.isValid);
			if (fail.length > 0) {
				this.$sf_showMessage({ icon: 'error', message: fail[0].message });
				return;
			}

			selectedRows = selectedRows.map(row => {
				if (row.commCdNameLangId == '[다국어 선택]') row.commCdNameLangId = null;
				if (row.commCdDescLangId == '[다국어 선택]') row.commCdDescLangId = null;
				return row;
			});

			this.$sf_toggleLoading(true);
			this.saveCommCd_(selectedRows)
				.then(({ code, message }) =>
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message
					})
				)
				.finally(() => this.$sf_toggleLoading(false));
		},
		deleteCommCd() {
			this.$sf_toggleLoading(true);
			this.deleteCommCd_(this.getSelectedRows())
				.then(res => res && this.$sf_toast({ ...res, type: res.code === 0 ? 'ok' : 'error' }))
				.finally(() => this.$sf_toggleLoading(false));
		},

		// COMM_CD_LANG methods
		setMenuName(param) {
			if (this.commCdLangModal.codeType == 'name') this.editRow.commCdNameLangId = param.langId;
			else if (this.commCdLangModal.codeType == 'desc') this.editRow.commCdDescLangId = param.langId;
		},
		commCdNameLangIdClick(row) {
			this.editRow = row;

			const { currentPage, pageUnit } = this.commCdLangModal.groups;
			this.$sf_toggleLoading(true);
			this.selectCommCdLangList_({ currentPage, pageUnit }).finally(() => {
				this.$sf_toggleLoading(false);
			});
			this.SET({ key: 'commCdLangModal', value: { ...this.commCdLangModal, show: true, isButtonOpened: false, codeType: 'name' } });
		},
		commCdDescLangIdClick(row) {
			this.editRow = row;

			const { currentPage, pageUnit } = this.commCdLangModal.groups;
			this.$sf_toggleLoading(true);
			this.selectCommCdLangList_({ currentPage, pageUnit }).finally(() => {
				this.$sf_toggleLoading(false);
			});
			this.SET({ key: 'commCdLangModal', value: { ...this.commCdLangModal, show: true, isButtonOpened: false, codeType: 'desc' } });
		}
	},
	watch: {
		rows() {
			const target = _.first(this.$refs.table.$el.getElementsByClassName('el-table__body-wrapper')) || {};
			target.scrollLeft = 0;
		}
	}
};
</script>
